import axios, { AxiosResponse } from 'axios';
import { getBaseDomain } from '@/requestManager';

const GET_UPLOAD_SHOOTING_URL     = '/api/upload-shootings/{id}/pin-data';
const PIN_PANORAMAS_TO_POINTS_URL = '/api/v2/upload-shootings/{id}/pin-panoramas-to-points';

export const getUploadShootingRequest = (id: number): Promise<AxiosResponse> => {
  const getUploadShootingUrl: string =
    getBaseDomain() + GET_UPLOAD_SHOOTING_URL.replace(/{id}/g, String(id));
  return axios.get(getUploadShootingUrl);
}

export const pinPanoramasToPointsRequest = (
  id: number,
  panoramasToPoints: {
    panoramaId: number;
    pointId: number;
  }[]
): Promise<AxiosResponse> => {
  const pinPanoramasToPointsUrl: string =
    getBaseDomain()
    + PIN_PANORAMAS_TO_POINTS_URL.replace(/{id}/g, String(id));

  return axios.post(pinPanoramasToPointsUrl, {
    panoramasToPoints,
  });
}
